var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('DailyReportsHeader',{attrs:{"items":_vm.items},on:{"filter":_vm.fetchData}}),_c('v-row',[_c('v-col',{staticClass:"ml-3"},[_c('h4',[_vm._v("Daily report")])])],1),(_vm.loading)?_c('div',[_c('loader-single')],1):_vm._e(),_c('DailyReportsList',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }